import { render, staticRenderFns } from "./planYoung.vue?vue&type=template&id=431b7350&scoped=true"
import script from "./planYoung.vue?vue&type=script&lang=js"
export * from "./planYoung.vue?vue&type=script&lang=js"
import style0 from "./planYoung.vue?vue&type=style&index=0&id=431b7350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b7350",
  null
  
)

export default component.exports